import { connect } from "react-redux";
import { withTranslation } from "react-i18next";

import Terms from "../components/Terms";

const mapStateToProps = state => ({});
const mapDispatchToProps = dispatch => ({});

const connectedComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(Terms);
const withTranslationComponent = withTranslation(["terms", "common"])(connectedComponent);

export default withTranslationComponent;



// WEBPACK FOOTER //
// ./src/containers/Terms.js